export default __webpack_public_path__ + "49bf117fec6adef70f40a988307d2eed.svg";